module.exports = __webpack_public_path__ + "img/sb1.4b56e07b.png";